<style scoped>
    .f-width {
        max-width:auto;
        white-space:nowrap;
    }
    td.rm-p-m {
        margin: 0px !important;
        padding: 0px !important;
    }
    td.meta-desc-w {
        width: auto;
    }
    .fix-w {
        margin-left: 22px !important;
    }
    .m-desc {
        color: #a97f28;
    }
</style>

<template>
    <div class="p-3" color="light">
        <div class="d-flex">
            <h5 class="subtitle-2">
                Integration Meta Configs
            </h5>
            <v-btn
                small
                class="ml-auto"
                color="primary"
                @click="showTips = !showTips">
                VIEW AVAILABLE META
            </v-btn>
        </div>
        <v-alert
            :value="showTips"
            outlined
            color="primary"
            dark
            border="right"
            transition="scale-transition">

            <v-row>
                <v-row>
                <v-col md="6">
                    <v-simple-table :light="true">
                        <template>
                            <thead>
                                <tr>
                                    <th><h5>Platform Meta</h5></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(meta, index) in metaTips.platform_meta"
                                    v-show="showPlatformMeta(index)"
                                    :key="'tips-' + index">
                                    <td class="f-width">{{ index }}</td>
                                    <td class="rm-p-m">
                                        <div>Example: {{ meta.example }}</div>
                                        <div class="m-desc"><span>Description: </span>{{ meta.description }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>

                <v-col md="6">
                    <v-simple-table :light="true">
                        <template>
                            <thead>
                                <tr>
                                    <th><h5>Global Meta</h5></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(meta, index) in metaTips.global_meta"
                                    :key="'tips-' + index">
                                    <td class="f-width">{{ index }}</td>
                                    <td class="rm-p-m">
                                        <div>Example: {{ meta.example }}</div>
                                        <div class="m-desc"><span>Description: </span>{{ meta.description }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>

                </v-row>
            </v-row>

        </v-alert>

        <div v-if="hasAuthenticate" class="mt-3 mb-3">
            <v-btn v-if="hasOauth2" small :disabled="isAuthenticating" @click="onAuthenticate">
                <i v-if="isAuthenticating" class="fa fa-circle-notch fa-spin mr-1"></i>
                {{ isAuthenticating ? 'Authenticating please wait...' : 'Authenticate' }}
            </v-btn>

            <v-btn v-if="hasOauth1" small @click="onAuthenticateOauth">
                <i v-show="isAuthenticatingOauth" class="fa fa-circle-notch fa-spin mr-1"></i>
                {{ isAuthenticatingOauth ? 'Authenticating please wait...' : 'Refresh authentication' }}
            </v-btn>

            <v-btn small @click="showShipmentSchema" class="ml-2">
                <i v-show="fetchingShipmentSchema" class="fa fa-circle-notch fa-spin mr-1"></i>
                {{ fetchingShipmentSchema ? 'Fetching schema please wait...' : 'Shipment Schema' }}
            </v-btn>

            <MyobAcumaticaShipmentSchema :integrationId="integrationId" :schema="shipmentSchema" v-if="showMyobShipmentSchemaModal" @myobShipmentSchemaModalClose="showMyobShipmentSchemaModal = false" />

        </div>

        <v-form
            ref="metaForm"
            v-if="items"
            v-model="form"
            :disabled="is_disabled">
            <v-container fluid>
                <div
                    v-for="(item, index) in prepareMapItems(items)"
                    :key="item.id">
                    <v-hover v-show="checkMeta(item.meta_key) <= -1">
                        <v-row align="center" class="grey lighten-5 pb-3">
                            <v-col lg="3">
                                <v-text-field
                                    v-model="item.meta_key"
                                    type="text"
                                    label="Meta key"
                                    :rules="[v => !!v || 'Meta key is required']"
                                    :readonly="is_disabled">
                                </v-text-field>
                            </v-col>
                            <v-col lg="6">
                                <v-text-field
                                    v-model="item.meta_value"
                                    type="text"
                                    label="Meta value"
                                    :rules="[v => !!v || 'Meta value is required']"
                                    :readonly="is_disabled">
                                </v-text-field>
                            </v-col>

                            <v-col v-if="!is_disabled" sm="2" class="ml-auto text-right">
                                <span class="ic-remove clickable" @click="onRemove(item, index)">
                                    <i class="fa fa-times-circle fa-2x"></i>
                                </span>
                            </v-col>
                        </v-row>
                    </v-hover>
                </div>
            </v-container>
        </v-form>

        <div class="mt-3 d-flex" v-if="!is_disabled">
            <v-spacer></v-spacer>
            <v-btn class="mr-1" small @click="onAddMore">Add more configurations</v-btn>
            <v-btn small color="primary" @click="onSubmit" :disabled="isSubmit">
                <span v-if="isSubmit">
                    <v-progress-circular
                      indeterminate
                        size="12"
                        width="2"
                      color="green darken-3">
                    </v-progress-circular>
                    saving
                </span>
                <span v-else>save</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import MyobAcumaticaShipmentSchema from "@/js/components/integrations/modal/MyobAcumaticaShipmentSchema";

export default {

    components: {
        MyobAcumaticaShipmentSchema
    },

    props: {
        hasOauth2: { type: Boolean, default: false },
        hasOauth1: { type: Boolean, default: false },
        integrationMeta: { type: Array, default: [] },
        is_disabled: { type: Boolean, default: false },
        metaTips: { type: Object, default: [] },
        integration: {type: Object, default: [] }
    },

    data() {
        return {
            items: this.integrationMeta,
            form: null,
            isSubmit: false,
            hasAuthenticate: this.hasOauth2 || this.hasOauth1, // has option to authenticate
            isAuthenticating: false,
            integrationId: null,
            showTips: false,
            hideMeta: [],
            isAuthenticatingOauth: false,

            showMyobShipmentSchemaModal: false,
            shipmentSchema: null,
            fetchingShipmentSchema: false
        }
    },

    mounted() {
        if (!this.integrationId) {
            this.integrationId = this.$route.params.id;
        }
    },

    methods: {
        checkMeta(metas) {
            return this.hideMeta.indexOf(metas)
        },

        onAddMore() {

            this.items.push({
                meta_key: '',
                meta_value: '',
                integration_id: this.integrationId
            })
        },


        onRemove(itemMeta) {
            let index = this.items.findIndex(item => item == itemMeta)
            this.items.splice(index, 1)
            if (Number.isInteger(itemMeta.id)) {
                this.$http
                    .delete('/api/integrationmetas/' + itemMeta.id)
                    .then(() => {
                        EventBus.$emit('show-success', 'Successfully deleted integration meta.');
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err)
                    })
            }
        },

        onSubmit(e) {
            e.preventDefault();

            // validate
            if (this.items == null || this.items.length == 0) {
                return
            }


            if (this.$refs.metaForm.validate()) {
                this.isSubmit = true

                // allow background to process before proceeding on submit
                setTimeout(async () => {

                    await this.$http
                        .post('/api/integrationmetas/bulk', this.items)
                        .then(({ data }) => {
                            EventBus.$emit('show-success', 'Successfully saved configurations.')
                            if (
                                data.data &&
                                data.data.attributes &&
                                data.data.attributes.metas
                            ) {
                                this.items = this.prepareMapItems(data.data.attributes.metas)
                            }
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err)
                        })

                    this.isSubmit = false

                }, 500);
            }


        },

        onAuthenticate() {
            this.isAuthenticating = true
            window.location.href = '/oauth2/' + this.integrationId + '/init'
        },

        onAuthenticateOauth() {
            this.isAuthenticatingOauth = true;
            this.$http
                    .post('/api/integrations/myob-advanced-auth', {integrationId: this.integrationId})
                    .then((result) => {
                        let modal = result.data.error === false ? 'show-success': 'show-error';
                        let message = result.data.message ?? '';
                        this.isAuthenticatingOauth = false;

                        EventBus.$emit(modal, message);
                    })
                    .catch(err => {
                        this.isAuthenticatingOauth = false;
                        EventBus.$emit('show-error', err);
                    });
        },

        prepareMapItems(data) {

            if (!data) {
                return [];
            }

            return data.filter(meta => {
                return !(meta.meta_key.indexOf('LIVE_RATE') >= 0) &&
                    !(meta.meta_key.indexOf('PACKING_GROUP_SETTINGS') >= 0) &&
                    !(meta.meta_key.indexOf('INTEGRATION_NOTE') >= 0) &&
                    !(meta.meta_key.indexOf('MACHSHIP_WEBHOOK') >= 0)
            })
        },

        showPlatformMeta(meta) {
            let hasMatch = false;

            for(let gmeta in this.metaTips.global_meta) {
                if (gmeta !== meta) {
                    hasMatch = true
                }
                else {
                    return false
                }
            }

            return hasMatch
        },

        showGlobalMeta(meta) {
            return Object.keys(this.metaTips.platform_meta).find(key => {
                return key === meta
            })
        },

        showShipmentSchema() {

            if(this.fetchingShipmentSchema) return;

            this.fetchingShipmentSchema = true;

            if(this.shipmentSchema != null) {
                this.showMyobShipmentSchemaModal = true;
                this.fetchingShipmentSchema = false;
                return;
            }

            this.$http
                .get('/api/myobacumatica/shipment-schema/' + this.integrationId)
                .then((data) => {
                    this.shipmentSchema = JSON.stringify(data.data, null, 2); // Format the JSON for better readability
                    this.showMyobShipmentSchemaModal = true;
                })
                .catch(err => {
                    EventBus.$emit('show-error', err)
                })
                .finally(() => {
                    this.fetchingShipmentSchema = false;
                });
        }
    }
}

</script>